import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import uploadImage from '../helpers/uploadImage';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const AdminEditBanner = ({ onClose, bannerData, fetchData }) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    id: bannerData?._id || "",
    desktopImage: bannerData?.desktopImage || "",
    mobileImage: bannerData?.mobileImage || "",
  });

  const handleUploadImage = async (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    const uploadedImage = await uploadImage(file);
    setData((prev) => ({ ...prev, [type]: uploadedImage.url }));
  };

  const handleDeleteImage = (type) => {
    setData((prev) => ({ ...prev, [type]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(SummaryApi.updateBanner.url, {
      method: SummaryApi.updateBanner.method,
      headers: { "content-type": "application/json" },
      credentials: 'include',
      body: JSON.stringify(data),
    });
    const responseData = await response.json();
    if (responseData.success) {
      toast.success("Banner updated successfully");
      onClose();
      fetchData();
      navigate(0);
    } else {
      toast.error(responseData.message || "Update failed");
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 right-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
        <div className='flex justify-between items-center pb-3'>
          <h2 className='font-bold text-lg'>Edit Banner</h2>
          <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>

        <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
          {/* Desktop Image Upload */}
          <label>Desktop Image:</label>
          <label className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.desktopImage ? (
                <div className='relative group'>
                  <img src={data.desktopImage} alt='Desktop Banner' className='h-32' />
                  <div className='absolute top-0 right-0 p-1 text-white bg-red-600 rounded-full cursor-pointer' onClick={() => handleDeleteImage("desktopImage")}>
                    <MdDelete />
                  </div>
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center gap-2'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Desktop Image</p>
                  <input type='file' className='hidden' onChange={(e) => handleUploadImage(e, "desktopImage")} />
                </div>
              )}
            </div>
          </label>

          {/* Mobile Image Upload */}
          <label>Mobile Image:</label>
          <label className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.mobileImage ? (
                <div className='relative group'>
                  <img src={data.mobileImage} alt='Mobile Banner' className='h-32' />
                  <div className='absolute top-0 right-0 p-1 text-white bg-red-600 rounded-full cursor-pointer' onClick={() => handleDeleteImage("mobileImage")}>
                    <MdDelete />
                  </div>
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center gap-2'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Mobile Image</p>
                  <input type='file' className='hidden' onChange={(e) => handleUploadImage(e, "mobileImage")} />
                </div>
              )}
            </div>
          </label>

          <button className='px-3 py-2 bg-red-600 text-white hover:bg-red-700'>Update Banner</button>
        </form>
      </div>
    </div>
  );
};

export default AdminEditBanner;
